import { AppError } from '@/types/errors';

// Normalize any caught error into an AppError
export function processError(error: unknown): AppError {
  if (error instanceof AppError) return error;
  if (error instanceof Error) return AppError.fromRaw(error.message, 500);
  return AppError.fromRaw(String(error), 500);
}

// Extract user-friendly message
export function getUserMessage(error: unknown): string {
  if (error instanceof AppError) return error.userMessage;
  if (error instanceof Error) return error.message;
  return 'Something unexpected happened. Please try again.';
}

// Extract field-level validation errors
export function getFieldErrors(error: unknown): Record<string, string> | null {
  if (error instanceof AppError && error.details?.fields) return error.details.fields;
  return null;
}

export function isSmartfloError(error: unknown): boolean {
  return error instanceof AppError && error.source === 'SMARTFLO';
}

export function isRetryable(error: unknown): boolean {
  return error instanceof AppError && error.retryable;
}

export function isNetworkError(error: unknown): boolean {
  return error instanceof AppError && error.category === 'NETWORK';
}

export function isAuthError(error: unknown): boolean {
  return error instanceof AppError && error.category === 'AUTH';
}

export function isValidationError(error: unknown): boolean {
  return error instanceof AppError && error.category === 'VALIDATION';
}

// Logs full diagnostic info to browser console (dev only)
export function logDiagnostics(error: unknown): void {
  if (process.env.NODE_ENV === 'production') return;
  if (error instanceof AppError) {
    console.group(`[Error Diagnostics] ${error.code}`);
    console.log('Error ID:', error.errorId);
    console.log('Source:', error.source);
    console.log('Category:', error.category);
    console.log('Status:', error.statusCode);
    console.log('Message:', error.userMessage);
    console.log('Retryable:', error.retryable);
    if (error.details) console.log('Details:', error.details);
    console.log('Timestamp:', error.timestamp);
    console.groupEnd();
  } else {
    console.error('[Error Diagnostics]', error);
  }
}
